import React from 'react';
import { Label } from '../ui/label';
import { cn } from '../../lib/utils';

interface RequiredLabelProps {
    htmlFor?: string;
    required?: boolean;
    className?: string;
    children: React.ReactNode;
}

export function RequiredLabel({ htmlFor, required, className, children }: RequiredLabelProps) {
    return (
        <Label htmlFor={htmlFor} className={cn('text-sm font-medium', className)}>
            {children}
            {required && <span className="ml-1 text-red-600" aria-hidden="true">*</span>}
        </Label>
    );
}

